import { SearchResultQueryDocument } from '@modules/libs/graphql/generated/graphql';
import { gqlQuery } from '@modules/libs/graphql/gql-config';
import { IFilterConditions, ISearchResultRepository } from '@modules/search/application/ports/searchResult.repository.port';
import { ModuleType } from '@shared/types/module.type';
import { left, right } from '@shared/utils/either.utils';
import { SearchResultEntityMapper } from '../../outbound/ports/searchResult.mapper';
export class SearchResultRepositoryImpl implements ISearchResultRepository {
  async getResult(keyword: string, category: ModuleType, offset: number, limit: number, filterConditions: IFilterConditions): ISearchResultRepository.getResultOutput {
    try {
      const {
        data
      } = await gqlQuery({
        query: SearchResultQueryDocument,
        variables: {
          where: {
            tab: category,
            title: keyword,
            ...filterConditions
          },
          pagination: {
            limit,
            offset
          }
        }
      });
      return right(SearchResultEntityMapper.toDomain(data.getSearchResult));
    } catch (error: any) {
      return left(error);
    }
  }
}